module.exports = __webpack_public_path__ + "static/media/wyoming.e734bea5.jpg";